/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { CMD } from "../../commands/CMD";
import { UploadAssetDialog } from "./UploadAssetDialog";
import { Editor } from "../../Editor";

export function registerAssetCommands(dc: Editor): void {
	const commandsSvc = dc.get("commandsService");
	const dialogSvc = dc.get("dialogService");

	commandsSvc.register({
		id: CMD.ASSET.CREATE.OPEN_ADD,
		label: "Open a dialog to add new asset",
		args: [
			{
				label: "Base path",
				isOptional: true,
				schema: {
					type: "string"
				}
			}
		],
		returns: "none",
		handler: async (args) => {
			const basePath = args[0] as string;

			dialogSvc.open(UploadAssetDialog, "addAsset", { basePath });
		}
	});

	commandsSvc.register({
		id: CMD.ASSET.EDIT.UPDATE,
		label: "Open a dialog to reupload asset",
		args: [
			{
				label: "Asset ID",
				isOptional: false,
				schema: {
					type: "string"
				}
			}
		],
		returns: "none",
		handler: async (args) => {
			const assetId = args[0] as string;

			dialogSvc.open(UploadAssetDialog, "updateAsset", { assetId });
		}
	});
}
